import React from 'react';
import { Player } from '../constants/types';
import { FaTwitter, FaWikipediaW, FaInstagram, FaGlobe } from "react-icons/fa6"

interface PlayerCardProps {
    key: number;
    player: Player;
}


const PlayerCard = ({ player }: PlayerCardProps) => {
    return (
        <div id={player.player_name.toLowerCase().replace(' ', '_')} style={{
            border: '1px solid #ddd',
            borderRadius: '8px',
            padding: '15px',
            marginBottom: '20px',
            textAlign: 'center',
            backgroundColor: '#f9f9f9',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            position: 'relative'
        }}>
            <span style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#333',
            }}>
                #{player.jersey_number}
            </span>
            <img src={player.player_picture} alt={`${player.player_name}`} style={{ width: '100px', borderRadius: '50%' }} />
            <h3 style={{ margin: '10px 0', color: "#4b0684" }}>{player.player_name}</h3>
            <div style={{ margin: '0 10px', lineHeight: '1.5', color: '#666', minHeight: '170px' }}>
                <p>Position: <span style={{ color: '#333' }}>{player.position}</span></p>
                {player.team && <p>Team: <span style={{ color: '#333' }}>{player.team}</span></p>}
                <p style={{ color: '#333' }}>{player.age} years old</p>
                {player.place_of_birth && <p>Place of Birth: <span style={{ color: '#333' }}>{player.place_of_birth}</span></p>}

            </div>
            <div style={{ marginTop: '15px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                {player.twitter && <a href={player.twitter} target="_blank" rel="noreferrer"><FaTwitter style={{ color: '#1DA1F2', width: '30px' }} /></a>}
                {player.instagram && <a href={player.instagram} target="_blank" rel="noreferrer"><FaInstagram style={{ color: '#E4405F', width: '30px' }} /></a>}
                {player.wikipedia && <a href={player.wikipedia} target="_blank" rel="noreferrer"><FaWikipediaW style={{ color: '#000000', width: '30px' }} /></a>}
                {player.website && <a href={player.website} target="_blank" rel="noreferrer"><FaGlobe style={{ color: '#4CAF50', width: '30px' }} /></a>}
            </div>
        </div>
    );
};

export default PlayerCard;
